/**
 * CAA (Coastal Aquaculture Authority) Maximum Stocking Density Limits
 * These are the maximum allowed stocking densities per square meter (m²) as per CAA guidelines
 */

export const CAA_MAX_STOCKING_DENSITY = {
  'Vannamei': 60.0,   // White Leg Shrimp (Litopenaeus Vannamei / Penaeus Vannamei)
  'Indicus': 40.0,    // Indian White Shrimp (Penaeus indicus)
  'Monodon': 12.0,    // Black Tiger Prawn (Penaeus Monodon)
  'Scampi': 12.0,     // Scampi (Macrobrachium rosenbergii) - treated like Monodon for underwriting
};

/**
 * Get the maximum allowed stocking density for a species
 * @param {string} species - Species name (Vannamei, Indicus, Monodon, Scampi)
 * @returns {number} Maximum stocking density per m², or null if species not found
 */
export const getMaxStockingDensity = (species) => {
  if (!species) return null;
  const normalizedSpecies = species.charAt(0).toUpperCase() + species.slice(1).toLowerCase();
  return CAA_MAX_STOCKING_DENSITY[normalizedSpecies] || null;
};

/**
 * Validate stocking density against CAA limits
 * @param {string} species - Species name
 * @param {number} density - Stocking density per m²
 * @returns {object} { isValid: boolean, errorMessage: string }
 */
export const validateStockingDensity = (species, density) => {
  if (!density || density <= 0) {
    return {
      isValid: false,
      errorMessage: 'Stocking density must be greater than 0'
    };
  }

  const maxDensity = getMaxStockingDensity(species);
  if (maxDensity === null) {
    return {
      isValid: false,
      errorMessage: `Unknown species: ${species}. Cannot validate stocking density.`
    };
  }

  if (density > maxDensity) {
    return {
      isValid: false,
      errorMessage: `Stocking density (${density}/m²) exceeds CAA maximum limit of ${maxDensity}/m² for ${species}. Please reduce to comply with CAA regulations.`
    };
  }

  return {
    isValid: true,
    errorMessage: ''
  };
};

